function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n  .wel-ac{fill:#F7FCFE;}\n  .wel-ac1{fill-rule:evenodd;clip-rule:evenodd;fill:#7CA3C2;}\n  .wel-ac2{fill:#E5EBF1;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "wel-ac",
  d: "M227.3,63.2c-8.9-8.9-23.4-8.9-32.4,0l-4.9,4.9L131.7,9.7c-8.9-8.9-23.4-8.9-32.4,0L27.8,81.3c0,0,0,0,0,0     L6.7,102.4c-8.9,8.9-8.9,23.5,0,32.4c8.9,8.9,23.4,8.9,32.4,0l4.9-4.9l58.3,58.4c8.9,8.9,23.4,8.9,32.4,0l92.6-92.7     C236.2,86.6,236.2,72.1,227.3,63.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac",
  d: "M57.6,43.4l19.8-19.8c4.7-4.7,4.7-12.3,0-17c-4.7-4.7-12.3-4.7-17,0L40.6,26.4c-4.7,4.7-4.7,12.3,0,17     C45.3,48.1,52.9,48.1,57.6,43.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac",
  d: "M254.4,93.6c-4.7-4.7-12.3-4.7-17,0l-19.8,19.8c-4.7,4.7-4.7,12.3,0,17c4.7,4.7,12.3,4.7,17,0l19.8-19.8     C259.1,105.9,259.1,98.3,254.4,93.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac",
  d: "M33.9,150.1l-12.7,12.7c-4.7,4.7-4.7,12.3,0,17c4.7,4.7,12.3,4.7,17,0l12.7-12.7c4.7-4.7,4.7-12.3,0-17     C46.2,145.4,38.6,145.4,33.9,150.1z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "wel-ac1",
  d: "M175,64h-6v-6c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v6h-6c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h6v6c0,1.1,0.9,2,2,2     c1.1,0,2-0.9,2-2v-6h6c1.1,0,2-0.9,2-2C177,64.9,176.1,64,175,64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac1",
  d: "M108,115c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H108z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac1",
  d: "M132.2,96.6c-0.8-0.8-2-0.8-2.8,0l-9.3,9.3V83c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v22.9l-9.3-9.3     c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8l12.7,12.7c0.8,0.8,2,0.8,2.8,0l12.7-12.7C132.9,98.6,132.9,97.4,132.2,96.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac1",
  d: "M167,79c-1.1,0-2,0.9-2,2v16v31c0,1.7-1.3,3-3,3H73c-1.7,0-3-1.3-3-3V71c0-1.7,1.3-3,3-3h63h16     c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2h-16H71c-2.8,0-5,2.2-5,5v61c0,2.8,2.2,5,5,5h93c2.8,0,5-2.2,5-5V97V81C169,79.9,168.1,79,167,79z     "
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac1",
  d: "M133,139h-31c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h31c1.1,0,2-0.9,2-2C135,139.9,134.1,139,133,139z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "wel-ac2",
  d: "M60,83h-6v-6c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v6h-6c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h6v6c0,1.1,0.9,2,2,2     c1.1,0,2-0.9,2-2v-6h6c1.1,0,2-0.9,2-2C62,83.9,61.1,83,60,83z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-ac2",
  d: "M191,112h-6v-6c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v6h-6c-1.1,0-2,0.9-2,2s0.9,2,2,2h6v6c0,1.1,0.9,2,2,2     c1.1,0,2-0.9,2-2v-6h6c1.1,0,2-0.9,2-2S192.1,112,191,112z"
}));

var SvgAddComputer = function SvgAddComputer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 258 198",
    style: {
      enableBackground: "new 0 0 258 198"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddComputer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_computer.5a30f8e3.svg";
export { ForwardRef as ReactComponent };